import { useMemo, useState } from 'react';

const useMainMenu = ({ menuItems, setSelectedField, isSingleFilterMode }) => {
  const [selectedFilterType, setSelectedFilterType] = useState(null);
  const [customFetchProps, setCustomFetchProps] = useState({});

  const actionMenuItems = menuItems.filter(({ isAction }) => isAction);
  const menuItemsWithoutActions = menuItems.filter(({ isAction }) => !isAction);

  const formatFilterTypeMenuItem = filterTypesMenu =>
    filterTypesMenu.map(({ id, isFreeInputs = false, ...menuItem }) => ({
      ...menuItem,
      id,
      isClickToOpenNextMenu: !isFreeInputs,
      isFreeInputs,
      isActive: selectedFilterType === id,
      onClick: ({ customFetchProps = {} } = {}) => {
        setCustomFetchProps(customFetchProps);
        setSelectedFilterType(id);
        if (isFreeInputs) setSelectedField(id);
      }
    }));

  const mainMenu = useMemo(() => {
    return {
      id: 'filterType',
      header: 'Select filter type:',
      actions: formatFilterTypeMenuItem(actionMenuItems),
      menuItems: formatFilterTypeMenuItem(menuItemsWithoutActions)
    };
  }, [menuItems]);

  return {
    mainMenu,
    customFetchProps,
    selectedFilterType,
    setSelectedFilterType
  };
};

export default useMainMenu;
